import { render, staticRenderFns } from "./edit-forecast.vue?vue&type=template&id=67da179c&scoped=true"
import script from "./edit-forecast.vue?vue&type=script&lang=js"
export * from "./edit-forecast.vue?vue&type=script&lang=js"
import style0 from "./edit-forecast.vue?vue&type=style&index=0&id=67da179c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da179c",
  null
  
)

export default component.exports